import React from 'react';

import { ExperimentName, EXPERIMENTS } from 'utils/constants/experiment-configs';
import { useExperiment } from 'utils/customHooks/useExperiment';

import { CheckIcon, SecurityText, SecurityTextWrapper } from './SecurityBadgesBadge-styled-components';

interface SecurityBadgesBadgeProps {
  showBackground?: boolean;
}

export const SecurityBadgesBadge = ({ showBackground = true }: SecurityBadgesBadgeProps) => {
  const { isVariant: shouldDisplay } = useExperiment({
    experiment: EXPERIMENTS[ExperimentName.CHECKOUT_SECURITY_MESSAGING],
  });

  if (!shouldDisplay) {
    return null;
  }

  return (
    <SecurityTextWrapper $showBackground={showBackground}>
      <SecurityText>
        <CheckIcon>✓</CheckIcon>
        256-bit SSL encrypted
      </SecurityText>
      <SecurityText>
        <CheckIcon>✓</CheckIcon>
        HIPAA and PIPEDA compliant
      </SecurityText>
    </SecurityTextWrapper>
  );
};
